module.exports = __webpack_public_path__ + "img/circulo_banner.d780b185.png";